module.exports = __webpack_public_path__ + "img/gaodeditu.2d0e86ab.jpg";